/**
 * all ado initialization eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParameterCodec,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
import { InitializationRequest } from '../model/initializationRequest';
import { InitializationResponse } from '../model/initializationResponse';
import { BASE_PATH } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class InitializationApiService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1. 概要 ASWBEへの初期流入処理として、指定されたパラメータを基にユーザ共通情報、ならびに会員情報をS2で管理するASWDB(Tx)に保持する。会員情報については、S1 API使用確認APIを利用してCookie情報からログインステータスを判定し、未ログインでない場合のみ保持を行う。これにより、他のアプリケーションとASWBE間でログイン状態の引継ぎ(SSO)を実現する。  ### 【アクセス情報】&lt;br&gt; ASWTOPからの呼び出しは、以下のURLとする。   | 環境 | URL |  | :--- | :--- |  | 本番 | https://space.ana.co.jp/aswbe-initialization/api/v1/initialization |  | ステージング | https://stg.test.space.ana.co.jp/aswbe-initialization/api/v1/initialization |  | 開発 | https://dev.test.space.ana.co.jp/dev1/aswbe-initialization/api/v1/initialization&lt;br&gt;https://dev.test.space.ana.co.jp/dev2/aswbe-initialization/api/v1/initialization&lt;br&gt;https://dev.test.space.ana.co.jp/dev3/aswbe-initialization/api/v1/initialization&lt;br&gt;https://dev.test.space.ana.co.jp/dev4/aswbe-initialization/api/v1/initialization&lt;br&gt;https://dev.test.space.ana.co.jp/dev5/aswbe-initialization/api/v1/initialization |  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。  1. 以下の内容で操作オフィスを求める。    1. ASW TOP識別に基づく有償オフィスがALLDB（マスタ）に存在する場合、そのオフィス。   1. 上記以外の場合、有償日本オフィス。 1. オフィスがダミーオフィスと設定されていて、現在の実行環境が本番環境(設定ファイルにて環境を定義して判定する)の場合、ダミーオフィスの利用可否判定を行う。以下のいずれかの条件を満たす場合、ダミーオフィス利用不可とし、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。   1. アクセス元がANA社内ネットワーク内ではない　※クライアントIPは設定ファイルに定義し、定義したIPアドレス以外であればANA社内ネットワーク内ではないと判断。   1. 設定ファイルの共通鍵によりタイムスタンプの復号を行ったが、復号できない。   1. 復号されたタイムスタンプが10分以上過去である。 1. 使用可能状態(3:未ログイン)をパラメータとしてS1API使用確認APIを呼び出す。  ※ リクエストパラメータにアクセストークンが存在しない場合はアクセストークンが発行され、それをレスポンスとして受け取る。 1. S1API使用確認APIから以下のエラーが返却された場合、当処理のエラーとしてステータスコード400(Bad request)でエラー情報を返却して、本処理を終了する。   1. アクセストークンが異常  1. リクエストパラメータで外部より会員番号を受領した場合、   1. Aegis(iFly)より会員情報を取得する。   ※ iFly会員詳細情報照会APIを利用する。 1. iFly会員詳細情報照会APIまたは、iFly証憑情報取得APIからエラーが返却された場合、ステータスコード401(Unauthorized)でエラー情報を返却する。 1. リクエストパラメータで外部より企業IDを受領した場合、以下の処理を行う。   1. ユーザー共通情報.ANA Bizログインステータスにtrueを設定する。 1. ALLDB(Tx)にユーザ共通情報、ANA Bizログイン情報を登録する（会員情報、証憑情報はそれぞれiFly会員詳細情報照会API、iFly証憑情報照会APIで登録済み）。&lt;br&gt;   パーソナライズ情報にユーザ共通が既に存在する場合、上書きする。 1. パラメータのTTL延長フラグに1(TTLを延長する)を指定して、ALLDB(Tx)のパーソナライズ情報を取得する。&lt;br&gt; ※ パラメータのTTL延長フラグに1(TTLを延長する)を指定して取得を行うと、TTLが24時間延長される。 1. レスポンスとしてステータスコード200(正常)を返却する。  # 3. データ更新内容 1. ASWDB（Tx）のS2パーソナライズ情報   1. ユーザ共通情報配下の項目について以下の内容を登録・更新する。&lt;br&gt;権限情報取得キー:新規登録の場合、API使用確認APIの戻り値。上書きの場合は更新しない。&lt;br&gt; |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報のjSessionId|jSessionId|空（提携未使用）|| |ユーザ共通情報のMETA用識別|META用識別|ALLDB(マスタ)のオフィス情報のMETA識別|| |ユーザ共通情報のMETA用言語コード|META用言語コード|ALLDB(マスタ)の言語マスタの言語コード(メタデータ)|| |ユーザ共通情報の操作オフィスコード|操作オフィスコード|ALLDB(マスタ)のオフィス情報の操作オフィスコード|| |ユーザ共通情報の有償特典区分|有償特典区分|有償固定。上書きの場合は更新しない。|| |ユーザ共通情報の通貨コード|通貨コード|ALLDB(マスタ)のオフィス情報の通貨コード|| |ユーザ共通情報の言語情報|言語情報|リクエストパラメータの言語情報|| |ユーザ共通情報のPOS国コード|POS国コード|オフィスALLDB(マスタ)のオフィス情報のPOS国コード|| |ユーザ共通情報のAPFコード|APFコード|空（提携未使用）|| |ユーザ共通情報のご紹介ねっと経由識別|ご紹介ねっと経由識別|空（提携未使用）|| |ユーザ共通情報のご紹介ねっと紹介番号|ご紹介ねっと紹介番号|\&quot;\&quot;(空文字)。（提携未使用）|| |ユーザ共通情報のご紹介ねっと紹介者名(姓)|ご紹介ねっと紹介者名(姓)|\&quot;\&quot;(空文字)。（提携未使用）|| |ユーザ共通情報のご紹介ねっと紹介者名(名)|ご紹介ねっと紹介者名(名)|\&quot;\&quot;(空文字)。（提携未使用）|| |ユーザ共通情報の端末識別|条件より導出した端末識別|リクエストヘッダのUser Agent|1 User Agentに、\&quot;iPhone\&quot;, \&quot;Android\&quot;, \&quot;iPod\&quot;を含む場合、SP&lt;br&gt;2 \&quot;Android\&quot;及び\&quot;任意の数字1桁[半角スペース]Safari\&quot;を含む、または\&quot;iPad;\&quot;を含む場合、タブレット扱いとする。タブレット以外の場合は\&quot;0 Mobile Safari\&quot;のように、\&quot;Mobile\&quot;が含まれる為、\&quot;0 Safari\&quot;という文字が存在する場合はTAB&lt;br&gt;3 上記以外の場合はPC| |ユーザ共通情報のブラウザ識別|条件より導出したブラウザ識別|リクエストヘッダのUser Agent|1 User Agentに、\&quot;MSIE\&quot;を含む場合はIE&lt;br&gt;2 \&quot;Firefox\&quot;を含む場合はFireFox&lt;br&gt;3 \&quot;Chrome\&quot;を含む場合はChrome&lt;br&gt;4 \&quot;Safari\&quot;を含む場合はSafari&lt;br&gt;5 \&quot;Edg\&quot;を含む場合はEdge&lt;br&gt;6 その他の場合は不明| |ユーザ共通情報のモバイルデバイス種別|条件より導出したモバイルデバイス種別|リクエストヘッダのUser Agent|1 User Agentに、\&quot;iPhone\&quot;を含む場合はiPhone&lt;br&gt;2 \&quot;iPodを含む場合はiPod&lt;br&gt;3 \&quot;iPad\&quot;を含む場合はiPad&lt;br&gt;4 \&quot;Android\&quot;を含む場合はAndroid&lt;br&gt;5 その他の場合は不明| |ユーザ共通情報のOSバージョン(モバイル)|条件より導出したOSバージョン(モバイル)|リクエストヘッダのUser Agent|1 iPhone,iPod,iPadの場合、\&quot;OS\&quot;と半角スペースの間にある数値&lt;br&gt;2 Androidの場合、Androidと\&quot;;\&quot;(セミコロン)の間にある数値&lt;br&gt;3 それ以外の場合は空| |ユーザ共通情報のANAアプリフラグ|条件より導出したANAアプリフラグ|空（提携未使用）|| |ユーザ共通情報のログインステータス|ログインステータス|API使用確認APIの戻り値のログインステータス|| |ユーザ共通情報のANA Bizログインステータス|ANA Bizログインステータス|未ログイン(ANA Bizログインステータスが未登録の場合)|| |ユーザ共通情報のダミーオフィスフラグ|ダミーオフィスフラグ|ALLDB(マスタ)のオフィス情報のダミーオフィスフラグ|| |ユーザ共通情報のANA Bizログイン情報|ANA Bizログイン情報|リクエストパラメータの企業ID, 企業名, クレジットカードID, 発券可否識別, 利用可能運賃カテゴリリスト, 発券手段, 法人用汎用項目1, 法人用汎用項目2, 法人用汎用項目3||   1. 会員情報配下の項目については会員データ(参照)APIの戻り値を登録する。&lt;br&gt;  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public initializationPost(
    generated?: InitializationRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InitializationResponse>;
  public initializationPost(
    generated?: InitializationRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InitializationResponse>>;
  public initializationPost(
    generated?: InitializationRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InitializationResponse>>;
  public initializationPost(
    generated?: InitializationRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/initialization`;
    return this.httpClient.request<InitializationResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
